import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";

export default function Paywall({ title = "Réservé à Lis-Moi Premium", text }) {
  return (
    <div data-testid="paywall" className="rise card-paper mx-auto max-w-xl p-8 text-center sm:p-10">
      <span className="mx-auto grid h-16 w-16 place-items-center rounded-full text-white" style={{ background: "linear-gradient(135deg,#F6B343,#E59819)" }}>
        <Lock size={28} />
      </span>
      <h2 className="mt-5 font-display text-3xl font-bold">{title}</h2>
      <p className="mt-3 text-lg text-[color:var(--muted-ink)]">
        {text || "Débloquez toutes les histoires, la lecture à voix haute, les ateliers de parole et 10 histoires inventées par l'IA chaque mois."}
      </p>
      <Link to="/premium" data-testid="paywall-cta-button" className="btn-primary mt-6"><Crown size={20} /> Voir les formules</Link>
    </div>
  );
}
